import { siteSettings } from "@workspace/utils";

export const courseConfigs = {
    MIM: {
        name: "MIM",
        displayName: "Masters in Management (MIM)",
        tabName: "MIM",
        schoolPricingTiers: [
            { id: 1, schools: 2, price: 79000 },
            { id: 2, schools: 3, price: 109000 },
            { id: 3, schools: 4, price: 129000 },
            { id: 4, schools: 5, price: 149000 },
            { id: 5, schools: 6, price: 169000 },
            { id: 6, schools: 7, price: 189000 },
            { id: 7, schools: 8, price: 209000 },
        ],
        additionalSchoolPrice: 15000,
        maxRegularTiers: 8,
        isPackageBased: false
    },
    MBA: {
        name: "MBA",
        displayName: "Master of Business Administration (MBA)",
        tabName: "MBA",
        packages: [
            { id: 1, name: "US & EU – 3 Schools", schools: 3, price: 275000, region: "US & EU" },
            { id: 2, name: "US & EU – 5 Schools", schools: 5, price: 350000, region: "US & EU" },
            { id: 3, name: "US & EU – 5 Schools (M7 + T7 EU)", schools: 5, price: 450000, region: "US & EU", premium: true },
            { id: 4, name: "Canada & Asia – 3 Schools", schools: 3, price: 250000, region: "Canada & Asia" },
            { id: 5, name: "Canada & Asia – 5 Schools", schools: 5, price: 350000, region: "Canada & Asia" },
        ],
        additionalSchoolPrice: 90000,
        isPackageBased: true
    },
    MFIN: {
        name: "MFIN",
        displayName: "Masters in Finance (MFin) or Master of Financial Engineering (MFE)",
        tabName: "MFin",
        schoolPricingTiers: [
            { id: 1, schools: 2, price: 89000 },
            { id: 2, schools: 3, price: 119000 },
            { id: 3, schools: 4, price: 139000 },
            { id: 4, schools: 5, price: 159000 },
            { id: 5, schools: 6, price: 179000 },
            { id: 6, schools: 7, price: 199000 },
            { id: 7, schools: 8, price: 219000 },
        ],
        additionalSchoolPrice: 17000,
        maxRegularTiers: 8,
        isPackageBased: false
    },
    MARKETING: {
        name: "MARKETING",
        displayName: "Masters in Marketing",
        tabName: "Marketing",
        schoolPricingTiers: [
            { id: 1, schools: 2, price: 84000 },
            { id: 2, schools: 3, price: 114000 },
            { id: 3, schools: 4, price: 134000 },
            { id: 4, schools: 5, price: 154000 },
            { id: 5, schools: 6, price: 174000 },
            { id: 6, schools: 7, price: 194000 },
            { id: 7, schools: 8, price: 214000 },
        ],
        additionalSchoolPrice: 16000,
        maxRegularTiers: 8,
        isPackageBased: false
    },
    MASTERS: {
        name: "MASTERS",
        displayName: "Specialised Masters",
        tabName: "Masters",
        schoolPricingTiers: [
            { id: 1, schools: 2, price: 84000 },
            { id: 2, schools: 3, price: 114000 },
            { id: 3, schools: 4, price: 134000 },
            { id: 4, schools: 5, price: 154000 },
            { id: 5, schools: 6, price: 174000 },
            { id: 6, schools: 7, price: 194000 },
            { id: 7, schools: 8, price: 214000 },
        ],
        additionalSchoolPrice: 16000,
        maxRegularTiers: 8,
        isPackageBased: false
    },
    BACHELORS: {
        name: "BACHELORS",
        displayName: "Bachelors degree",
        tabName: "Bachelors",
        packages: [
            { id: 1, name: "EU – 5 UG Schools", schools: 5, price: 375000, region: "EU" },
            { id: 2, name: "US Ivy League Mentoring (1 year) – 5 UG Schools", schools: 5, price: 475000, region: "US" },
            { id: 3, name: "US Ivy League Mentoring (2 year) – 5 UG Schools", schools: 5, price: 675000, region: "US", premium: true },
            { id: 4, name: "US Other Schools Mentoring (2 year) – 5 UG Schools", schools: 5, price: 575000, region: "US" },
            { id: 5, name: "Australia, Canada & Asia – 5 UG Schools", schools: 5, price: 350000, region: "Australia, Canada & Asia" },
            { id: 6, name: "Global Mix (Non-US) – 5 UG Schools", schools: 5, price: 500000, region: "Global Mix (Non-US)" },
        ],
        additionalSchoolPrice: 45000,
        isPackageBased: true
    }
};

export const pricingDetailsConfig = {
    cta: [
        // { href: "", text: "Purchase Package", className: "button is-fluid w-button" },
        { href: siteSettings.contact.whatsappUrl, text: "Queries", className: "button is-border w-button" }
    ],
    content: {
        title: "Start your admissions journey with GradBrew",
        paragraphs: [
            'After checkout, our team will reach out and set up all your tools within <strong>24 hours of purchase</strong>.',
            "Your journey begins right away: you’ll receive onboarding emails, connect with your mentors soon after, and get unlimited edits and real guidance. We stay with you till the job is done."
        ]
    },
    summary: {
        icon: {
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><title>c-info</title><g fill="#000000"><path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8,8-3.6,8-8S12.4,0,8,0Zm1,11.5c0,.276-.224,.5-.5,.5h-1c-.276,0-.5-.224-.5-.5V7.5c0-.276,.224-.5,.5-.5h1c.276,0,.5,.224,.5,.5v4Zm-1-5.5c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z" fill="currentColor"></path></g></svg>`
        },
        title: "See our pricing explained",
        arrowIcon: {
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><title>arrow-sm-down</title><g fill="#000"><path d="M8,11a1,1,0,0,1-.707-.293l-4-4A1,1,0,0,1,4.707,5.293L8,8.586l3.293-3.293a1,1,0,1,1,1.414,1.414l-4,4A1,1,0,0,1,8,11Z" fill="currentColor"></path></g></svg>`
        },
        content: [
            'You pay once for full access — no hidden fees, no ghostwriting.<br /> Need to split into 2 payments? We’re happy to help. <br /> 14-day cancellation available if work hasn`t started.'
        ],
        contact: {
            href: "/lets-talk",
            text: "Contact us",
            after: " to schedule an Expert call."
        }
    }
};


export const getPricingPlansConfig = (courseKey: string) => {
    const course = courseConfigs[courseKey as keyof typeof courseConfigs];

    if (!course) return [];

    if (course?.isPackageBased && 'packages' in course) {
        // For MBA - package-based pricing
        return course.packages.map((pkg, index) => ({
            // name: pkg.premium ? "Premium" : index === 0 ? "Smart Essential" : index === 1 ? "Most Popular" : "Maximum Reach",
            description: `<strong>${pkg.schools} Schools</strong><br /><h3>INR ${pkg.price.toLocaleString("en-IN")}</h3>`,
            // description: `${pkg.name}<br /><strong>${pkg.schools} Schools</strong><br /><h3>INR ${pkg.price.toLocaleString("en-IN")}</h3>`,
            name: `${pkg.name}`,
            cta: { text: "Choose Plan", href: `/pricing?course=${courseKey}&package=${index}` },
            active: index === 1, // Make second option active by default
            schools: pkg.schools,
            id: pkg.id,
            packageIndex: index,
            popular: index === 1 && !pkg.premium
        }));
    } else if ('schoolPricingTiers' in course) {
        // For other courses - tier-based pricing
        const tier1 = course.schoolPricingTiers.find(t => t.schools === 4);
        const tier2 = course.schoolPricingTiers.find(t => t.schools === 6);
        const tier3 = course.schoolPricingTiers.find(t => t.schools === 8);

        return [
            {
                name: "Smart Essential",
                description: `Perfect for targeted, high-fit applications. <br /><strong>${tier1?.schools} Schools</strong><br /><h3>INR ${tier1?.price.toLocaleString("en-IN")}</h3>`,
                cta: { text: "Choose Plan", href: `/pricing?course=${courseKey}&schools=4` },
                active: false,
                schools: tier1?.schools,
                id: tier1?.id,
                packageIndex: 0,
                popular: false,
            },
            {
                name: "Most Popular",
                description: `Best value to maximise admit potential. <br /><strong>${tier2?.schools} Schools</strong><br /><h3>INR ${tier2?.price.toLocaleString("en-IN")}</h3>`,
                cta: { text: "Choose Plan", href: `/pricing?course=${courseKey}&schools=6` },
                active: true,
                schools: tier2?.schools,
                id: tier2?.id,
                packageIndex: 1,
                popular: true,
            },
            {
                name: "Maximum Reach",
                description: `Great for widest options, strongest odds. <br /><strong>${tier3?.schools} Schools</strong><br /><h3>INR ${tier3?.price.toLocaleString("en-IN")}</h3>`,
                cta: { text: "Choose Plan", href: `/pricing?course=${courseKey}&schools=8` },
                active: false,
                schools: tier3?.schools,
                id: tier3?.id,
                packageIndex: 2,
                popular: false,
            }
        ];
    }

    return [];
};

export const calculatePrice = (courseKey: string, schools: number, packageIndex?: number) => {
    const course = courseConfigs[courseKey as keyof typeof courseConfigs];

    if (!course) return 0;

    if (course.isPackageBased && 'packages' in course && packageIndex !== undefined) {
        return course.packages[packageIndex]?.price || 0;
    }

    if ('schoolPricingTiers' in course) {
        const tier = course.schoolPricingTiers.find(t => t.schools === schools);
        if (tier) {
            return tier.price;
        } else if (schools > course.maxRegularTiers) {
            const lastTier = course.schoolPricingTiers[course.schoolPricingTiers.length - 1];
            const base = lastTier ? lastTier.price : 0;
            return base + (schools - course.maxRegularTiers) * course.additionalSchoolPrice;
        }
    }

    return 0;
};


export const schoolPricingTiers = [
    { schools: 2, price: 79000 },
    { schools: 3, price: 109000 },
    { schools: 4, price: 129000 },
    { schools: 5, price: 149000 },
    { schools: 6, price: 169000 },
    { schools: 7, price: 189000 },
    { schools: 8, price: 219000 },
];
export const additionalSchoolPrice = 15000;

export const pricingHeaderConfig = {
    title: "MBA, MiM & Masters Prep Pricing",
    description: `Transparent MiM, MBA &amp; Master in Finance prep pricing, built for your goals and your pace. <br /> <strong>Every package includes unlimited edits, expert mentors, and personalised guidance </strong> — <br /> because your application should sound like you at your best.`
};

const tier1 = schoolPricingTiers.find(t => t.schools === 4);
const tier2 = schoolPricingTiers.find(t => t.schools === 6);
const tier3 = schoolPricingTiers.find(t => t.schools === 8);

export const pricingPlansConfig = [
    {
        name: "Smart Essential",
        description: `Perfect for targeted, high-fit applications. <br /><strong>2 Schools</strong><br /><h3>INR ${tier1?.price.toLocaleString("en-us")}</h3>`,
        cta: { text: "Choose Plan", href: "/pricing?schools=4" },
        active: false,
        schools: 4,
        popular: false,
    },
    {
        name: "Most Popular",
        description: `Best value to maximise admit potential. <br /><strong>4 Schools</strong><br /><h3>INR ${tier2?.price.toLocaleString("en-IN")}</h3>`,
        cta: { text: "Choose Plan", href: "/pricing?schools=6" },
        active: true,
        schools: 6,
        popular: true,
    },
    {
        name: "Maximum Reach",
        description: `Great for widest options, strongest odds. <br /><strong>6 Schools</strong><br /><h3>INR ${tier3?.price.toLocaleString("en-IN")}</h3>`,
        cta: { text: "Choose Plan", href: "/pricing?schools=8" },
        active: false,
        schools: 8,
        popular: false,
    }
];

export const pricingUSPConfig = [
    {
        // icon: "https://cdn.prod.website-files.com/620078109c717f09cbb8c542/64913136ce1ed295b0cb157c_puzzle-dark.svg",
        title: "No Hidden Fees. No Upsells.",
        paragraphs: [
            "What you see is what you pay — no hidden charges, no surprise fees.",
            "All packages include unlimited edits, expert mentor support, and strategic guidance from start to finish.",
            "<i>Note: We guide you on visa, loans, and language courses, and may refer trusted third-party partners who charge separately (e.g., a paid German course post-admit). Career Launcher is a separate platform with its own pricing and is not included in the admissions consulting package.</i>"
        ]
    },
    {
        // icon: "https://cdn.prod.website-files.com/620078109c717f09cbb8c542/649a4e499aa29e92e00f1bb3_customer-success.svg",
        title: "Dedicated Admissions Team",
        paragraphs: [
            "Once you sign up, your onboarding kit will arrive within 24 hours.",
            "A dedicated team — including a lead consultant — will help build your school list, plan your timeline, and begin working on CVs, essays, and other application materials immediately.",
            "Expect clear communication, personalised guidance, and a partnership that stays with you till the admit. We will work with you throughout the process."

        ]
    },
    {
        // icon: "https://cdn.prod.website-files.com/620078109c717f09cbb8c542/649a4e4531b3d7567990630e_success-plan.svg",
        title: "Upgrade Anytime",
        paragraphs: [
            "Need to apply to more schools later? No problem.",
            "You can upgrade your plan or add schools anytime — your previous work and progress stays intact.",
            "We maintain continuity across edits, mentor feedback, and strategy, so there’s no repetition for work already done.",
            "When you add a school, you only pay the additional margin cost per school. This ensures you're never penalised for evolving goals — whether you discover a new school mid-cycle or add an ambitious reach option late in the game."
        ]
    }
];
